export const UPDATE_SELECTION = 'UPDATE_SELECTION' as const;
export const UPDATE_INDEX = 'UPDATE_INDEX' as const;
export const UPDATE_HOVER = 'UPDATE_HOVER' as const;
